import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbUpOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.7 10.81c-1.428.067-1.997.361-2.26.625-.3.3-.64.994-.64 2.894v3.333c0 1.9.34 2.595.64 2.894.263.264.832.559 2.26.626zm1.8 10.386h8.996c1.72-.009 2.46-.315 2.852-.66.396-.35.8-1.06 1.043-2.79l.702-5c.245-1.742.01-2.294-.114-2.455-.082-.106-.432-.437-2.008-.488H12.7v-4.8c0-1.287-.385-1.881-.975-2.163a.37.37 0 0 0-.367.018.4.4 0 0 0-.207.316c-.215 2.644-1.386 4.759-3.146 6.95l-.505.627zm15.376-8.2c.504-3.59-.47-4.889-3.876-4.993h-4.5v-3c0-1.625-.516-3.08-2-3.787-1.415-.675-3.022.318-3.143 1.812-.174 2.14-1.107 3.917-2.755 5.968h-.269c-4 0-5.333 1.333-5.333 5.333v3.333c0 4 1.333 5.334 5.333 5.334H16.5c3.728-.018 5.15-1.276 5.673-5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ThumbUpOutlinedSize24Glyph.displayName = 'ThumbUpOutlinedSize24Glyph';
